import RootPage from './insured-messages.page.vue'
import NewCampaign from './new-campaign.page.vue'
import CampaignDetails from './campaign-details.page.vue'
import SendSingleMessagePage from './send-single-insured-message.page'


let routes = [
  {
    path: 'insured-messages',
    name: 'insured-messages',
    component: RootPage
  },
  {
    path: 'create-campaign',
    name: 'create-campaign',
    component: NewCampaign
  },
  {
    path: 'send-insured-message',
    name: 'send-insured-message',
    component: SendSingleMessagePage
  },
  {
    path: 'campaign-details',
    name: 'campaign-details',
    component: CampaignDetails
  },

]

export default routes
